import React, { useEffect, useRef, useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { useRequest } from '../hooks/useRequest';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const Notification = () => {
  const containerRef = useRef(null);
  const { request } = useRequest();
  const [messageUploading, setMessageUploading] = useState(0);
  const [notification, setNotification] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    request('post/getNotifications', {
      method: 'POST',
      body: {
        take: 10,
        skip: messageUploading * 10
      }
    }).then((res) => {
      setNotification([...notification.concat(res?.data?.result)]);
    });
  }, [messageUploading]);

  useEffect(() => {
    if (
      containerRef.current?.scrollIntoView({ behavior: 'smooth' }) &&
      notification[0]?.items?.hasNextPage
    ) {
      setMessageUploading(messageUploading + 1);
    }
  }, [containerRef, notification]);

  return (
    <section ref={containerRef} className="main-content">
      <div className="container">
        <div className="notifBlock">
          <FiArrowLeft size={40} onClick={() => navigate('/')} color="#3ca646" />

          <h1 className="notification-center">Bildirimler</h1>
        </div>
        {notification[0]?.items?.items &&
          notification[0].items.items.map((nf, i) => (
            <div key={i} className="notification-card">
              <div className="notification-card-top">
                <img src={nf.userProfilePhotoUrl} alt="" />
                <span>{nf.notificationText}</span>
                <span className="notification-card-top-arrow">
                  {' '}
                  <FiChevronRight />
                </span>
              </div>
              <div className="notification-card-bottom">{nf.timeInfo}</div>
            </div>
          ))}
      </div>
    </section>
  );
};

export default Notification;
